<template>
  <vs-row>
    <vs-row class="catBgClr mx-4">
      <vs-row>
        <h3 class="p-5 pb-4">Add Top Issuers</h3>
      </vs-row>

      <vs-row class="">
        <vs-col vs-lg="6" vs-sm="6" class="">
          <vs-row>
            <vs-col vs-lg="12">
              <div class="my-2 ml-5 pt-3">Issuer {{ topissuer.order }}</div>
              <vs-input
                id="transparent"
                v-model="topissuer.name"
                class="w-full p-3 pt-0 ml-2 pr-6"
                :disabled="true"
              />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          vs-lg="2"
          vs-sm="3"
          vs-type="flex"
          vs-justify="flex-start"
          class="ml-5"
        >
          <div class="items-center mt-12 pl-1">
            <p class="whiteText" style="direction: rtl">
              {{ allcardslist ? allcardslist.length : 0 }} /
              {{ removed_cards ? removed_cards.length : 0 }}
            </p>
            <p>Excluded Cards</p>
          </div>
        </vs-col>
      </vs-row>

      <vs-row>
        <div
          class="flex flex-wrap-reverse items-center ml-5 cursor mt-4 mb-3 pt-0"
          @click="addNewIssuer"
        >
          <PlusSquareIcon color="white" />
          <h6 class="ml-2 mt-1 cursor">Add Credit Card</h6>
        </div>
      </vs-row>

      <vs-row :key="index" v-for="(card, index) in removed_cards" class="ml-5">
        <vs-col vs-lg="6" vs-sm="6" class="pr-6">
          <vs-row>
            <vs-col vs-lg="12">
              <div class="my-2 pt-1 ml-1">Credit Card {{ index + 1 }}</div>

              <!--vs-input
                    v-model="removed_cards[index].name"
                    class="w-full pr-15 pl-3 pt-3 pb-3 ml-1"
                    :disabled="removed_cards.length == 0"
                  /-->
              <select
                v-if="allcardslist.length > 0"
                v-model="removed_cards[index].card"
                :class="{
                  'w-full posSelect  pl-2': true,
                }"
              >
                <option
                  v-for="card in allcardslist"
                  :key="card._id"
                  :value="card._id"
                >
                  {{ card.name }}
                </option>
              </select>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-lg="3" vs-sm="3" vs-type="flex" vs-justify="flex-start">
          <div
            v-if="
              removed_cards[index].isDeleteable ||
              removed_cards[index].isDeleteable == undefined
            "
            class="flex flex-wrap-reverse items-center cursor mt-5 pl-4"
            @click="removeCard(index)"
          >
            <MinusSquareIcon color="white" class="mt-5" />
            <div class="addCardFont font-semibold ml-3 cursor mt-6">Remove</div>
          </div>

          <div
            v-if="removed_cards[index].isDeleteable == false"
            class="cursor mt-5 pt-0 ml-1"
            style="opacity: 0.3"
          >
            <vs-row>
              <MinusSquareIcon color="white" class="mt-5" />
              <div class="addCardFont font-semibold ml-3 cursor mt-6">
                Remove
              </div>
            </vs-row>
          </div>
        </vs-col>
      </vs-row>

      <vs-row v-if="errors.removed_cards.success">
        <vs-col vs-lg="6" vs-sm="12" vs-type="flex" vs-justify="flex-start">
          <p class="pl-6 pt-5 pb-5 py-3 dangerColor">
            {{ errors.removed_cards.msg }}
          </p>
        </vs-col>
      </vs-row>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="updateStatus.status"
      >
        <div style="magine-bottom: 30px" class="mb-5">
          <h5>{{ updateStatus.msg }}</h5>
        </div>
        <div
          style="text-align: center; margin-top: 30px"
          vs-type="flex"
          vs-justify="center"
        >
          <vs-button
            class="mt-11"
            @click="tocheatsheet()"
            color="primary"
            type="filled"
            >Show Cheat Sheet</vs-button
          >
        </div>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="NoIssuer.status"
        @close="closefunc()"
      >
        <h5>{{ NoIssuer.msg }}</h5>
      </vs-popup>
    </vs-row>
    <vs-row class="mt-2 pr-10 pl-1" vs-justify="flex-end">
      <vs-button @click="updateRemovedCards">Save</vs-button>
    </vs-row>
  </vs-row>
</template>

<script>
import { PlusSquareIcon, MinusSquareIcon, MenuIcon } from "vue-feather-icons";
import draggable from "vuedraggable";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    MenuIcon,
    draggable,
  },

  data() {
    return {
      topissuer: "",
      current_remove_card: [],
      removed_cards: [],
      topissuerList: [],
      allcardslist: [],

      errors: {
        removed_cards: {
          msg: "",
          success: false,
        },

        duplicateIndices: [],
      },

      updateStatus: {
        msg: "",
        status: false,
      },
      NoIssuer: {
        msg: "",
        status: false,
      },
      genericErrorMessage,
      toast,
    };
  },
  methods: {
    closeupdate() {
      this.updateStatus = {
        status: false,
        msg: "",
      };
    },
    async tocheatsheet() {
      await this.closeupdate();
      this.$router.push({
        name: "cheatsheet",
        params: { edit: true },
      });
    },
    closefunc() {
      if (this.NoIssuer.status == true) {
        this.NoIssuer.status = false;
      } else {
        this.updateStatus = {
          status: false,
          msg: "",
        };

        this.$router.go(1);
      }
    },

    async removeCard(index) {
      if (this.removed_cards[index]._id) {
        await this.topissuerList.push(this.removed_cards[index]);

        await this.current_remove_card.splice(
          this.current_remove_card.findIndex(
            (a) => a._id == this.removed_cards[index]._id
          ),
          1
        );
      }
      this.removed_cards.splice(index, 1);
      await this.notempty();
    },
    async addNewIssuer() {
      if (await this.notempty()) {
        await this.removed_cards.push({ _id: "", card: "" });
        this.removed_cards = await this.removed_cards.map((value, index) => {
          return {
            _id: value._id,
            order: index + 1,
            card: value.card,
          };
        });
      }
    },
    getMainIssuer(inp) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise((resolve, reject) => {
          this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.CheatSheetDetail, {
              params: {
                cheatsheetId: inp,
              },
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            })

            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                resolve((this.topissuer = res.data.data.finalissuer));
                await this.getCardsList(this.topissuer.issuer);
                if (this.topissuer.removed_credit_card.length > 0) {
                  this.topissuer.removed_credit_card.forEach((v1) => {
                    this.removed_cards.push({
                      card: v1.card,
                      _id: v1._id,
                      date: v1.date,
                      order: v1.order,
                    });
                  });
                }
              } else {
                if (res.data.errors.issuers) {
                  this.NoIssuer = {
                    status: true,
                    msg: res.data.errors.issuers,
                  };
                }
                //this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
              this.$vs.loading.close();
            });
        });
      }, 500);
    },
    getCardsList(id) {
      return new Promise(async (resolve) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetIssuerCards, {
            params: {
              issuerId: id,
            },
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve((this.allcardslist = res.data.data));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    async notempty() {
      for (var i = 0; i < this.removed_cards.length; i++) {
        if (
          this.removed_cards[i].card == "" ||
          !this.removed_cards[i].card.trim()
        ) {
          this.errors.removed_cards = {
            msg: "Please fill out the card field",
            success: true,
          };
          return false;
        } else {
          this.errors.removed_cards = {
            msg: "",
            success: false,
          };
        }
      }
      return true;
    },
    async hasUniqueNames() {
      var tmpArr = [];
      for (var i = 0; i < this.removed_cards.length; i++) {
        if (tmpArr.indexOf(this.removed_cards[i].card) < 0) {
          tmpArr.push(this.removed_cards[i].card);
        } else {
          // this.error.duplicateIndices.push(i);
          return false;
        }
      }
      // console.log('indices are: ',indices);
      return true;
    },

    async updateRemovedCards() {
      this.hasUniqueNames(this.removed_cards);
      if (await this.notempty()) {
        if (await this.hasUniqueNames(this.removed_cards)) {
          this.errors.removed_cards = {
            msg: "",
            success: false,
          };
          let newVar = await this.removed_cards.map((value, index) => {
            return {
              //id: value._id,
              order: index + 1,
              card: value.card,
            };
          });
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.$vs.loading.close();
            this.$vs.loading({
              background: "rgba(1,2,3,.2)",
            });
            return new Promise((resolve, reject) => {
              this.$axios
                .post(
                  this.$ApiKeys.BASE_URL + this.$EndPoints.UpdateRemovedCards,
                  {
                    removed_cards: newVar,
                    issuerId: this.topissuer._id,
                  },
                  {
                    headers: {
                      Authorization: this.$localStorage.get("token"),
                    },
                  }
                )
                .then(async (res) => {
                  this.$vs.loading.close();
                  if (res.data.success) {
                    this.updateStatus = {
                      msg: res.data.data,
                      status: true,
                    };
                  } else {
                    this.toast(this.genericErrorMessage());
                  }
                })
                .catch((e) => {
                  if (e.response.data.errors.removed_cards) {
                    this.errors.removed_cards = {
                      msg: e.response.data.errors.removed_cards,
                      success: true,
                    };
                  } else {
                    this.errors.removed_cards = {
                      msg: "",
                      success: false,
                    };
                    if (e.response.status !== 401) {
                      this.toast(this.genericErrorMessage());
                    }
                  }
                  this.$vs.loading.close();
                });
            });
          }, 500);
        } else {
          this.errors.removed_cards = {
            msg: "All selected credit cards must be unique.",
            success: true,
          };
        }
      }
    },
  },
  created() {},
  mounted() {
    if (this.$route.params.id != undefined) {
      this.getMainIssuer(this.$route.params.id);
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>

<style>
.whiteText {
  color: white !important;
}
.con-vs-tooltip {
  margin-top: 20px;
  margin-left: 10px;
  /* padding-top: 20px; */
  /* background: green; */
}
.catBgClr {
  background-color: #1c1c1e;
  padding: 20px;
  border-radius: 10px;
}
.cursor {
  cursor: pointer;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
}
.manageButton {
  width: 207px;
  border-radius: 10, 21, 10, 21;
  font-size: 13px;
}
.posSelect {
  background-color: rgb(52, 52, 52) !important;
}

@media only screen and (min-width: 800px) {
  .text {
    margin-left: 35px;
    padding-left: 30px;
  }
}
@media only screen and (max-width: 800px) {
  .text {
    margin-left: 20px;
    padding-left: 10px;
  }
}
.vs-con-input {
  border: none;
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: hidden;
  outline: none;
}
.feather.feather-minus-square {
  color: #cacaca !important;
}
</style>
